"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  big: {
    size: 'xl',
    weight: 'extrabold',
    lineHeight: 's'
  },
  h1: {
    size: 'l',
    weight: 'extrabold',
    lineHeight: 's'
  },
  h2: {
    size: 'm',
    weight: 'extrabold',
    lineHeight: 'm'
  },
  h3: {
    size: 'base',
    weight: 'extrabold',
    lineHeight: 'l'
  },
  h4: {
    size: 'base',
    weight: 'medium',
    lineHeight: 'l'
  },
  h5: {
    size: 's',
    weight: 'semibold',
    lineHeight: 'l'
  },
  h6: {
    size: 's',
    weight: 'medium',
    lineHeight: 'l'
  },
  h7: {
    size: 'xs',
    weight: 'semibold',
    lineHeight: 'l'
  },
  h8: {
    size: 'xs',
    weight: 'medium',
    lineHeight: 'l'
  }
};
exports["default"] = _default;